import React from 'react';
import { useTranslation } from 'react-i18next';
import { Block, FlexColumn, FlexRow, HeroImage, LargeText, Spinner } from '@guryou/html-components';
import { stateIsLoaded, stateIsLoading, useVideoCourse } from '@guryou/redux';
import MyCard from '../myVideos/MyCard';

const VideoCourses = () => {
  const { t } = useTranslation();
  const videoCourses = useVideoCourse();

  const vcourses = (stateIsLoaded(videoCourses) && videoCourses?.data?.length && videoCourses.data) || [];

  return (
    <Block margin={0}>
      <Block
        margin={0}
        xs={12}
        height="550px"
        textAlign="center"
        backgroundImage={`url(${HeroImage})`}
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
        backgroundPositionX="center"
        backgroundPositionY="center"
      >
        <FlexRow background="#00000060" height="100%" width="100%" justifyContent="center" alignItems="center" margin={0}>
          <LargeText fontSize="3rem" fontWeight="800" color="white">
            {t('VIDEO_COURSE_PAGE.stay')}
          </LargeText>
        </FlexRow>
      </Block>
      <FlexColumn marginTop={15}>
        <LargeText fontSize="3rem" textTransform="capitalize" marginBottom={3}>
          {t('VIDEO_COURSE_PAGE.videoCourses')}
        </LargeText>
        <LargeText>{t('VIDEO_COURSE_PAGE.forBest')}</LargeText>
      </FlexColumn>
      <FlexRow margin={6} justifyContent="center" xs={12}>
        {stateIsLoading(videoCourses) ? <Spinner /> : vcourses?.map(x => <MyCard key={x.id} item={x} to="video-courses" />)}
      </FlexRow>
    </Block>
  );
};

export default VideoCourses;
